import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/sharedDownloadStates";
import deltas from "../../actions/deltas";

const {SET_DOWNLOAD_FINANCE_REPORT_STATE} = deltas.actionTypes;

export default createStateReducer(states, null, SET_DOWNLOAD_FINANCE_REPORT_STATE);

export const selectIsLoadingDownloadFinanceReport = (state) => states.LOADING === state.states.downloadFinanceReport.state;
